/**
 * SF34 — Owner Pilot Workflow
 * मालिक pilot workflow — audio/video/file/browser/Smart Print end-to-end
 */
const WORKFLOW_STEPS = Object.freeze([
    Object.freeze({
        stepId: 'pilot-01',
        name: 'audio_source_validate',
        fromState: 'intake_requested',
        toState: 'consent_required',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'audio source validate: format, size, duration check',
    }),
    Object.freeze({
        stepId: 'pilot-02',
        name: 'consent',
        fromState: 'consent_required',
        toState: 'metadata_validated',
        requiresOwnerApproval: true,
        auditRequired: true,
        description: 'owner consent for audio processing',
    }),
    Object.freeze({
        stepId: 'pilot-03',
        name: 'budget_check',
        fromState: 'metadata_validated',
        toState: 'transcription_dry_run',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'budget check: duration, cost, provider call limit',
    }),
    Object.freeze({
        stepId: 'pilot-04',
        name: 'transcription_dry_run',
        fromState: 'transcription_dry_run',
        toState: 'transcription_owner_approved',
        requiresOwnerApproval: true,
        auditRequired: true,
        description: 'dry-run preview -> owner approval for real transcription',
    }),
    Object.freeze({
        stepId: 'pilot-05',
        name: 'transcript_redaction',
        fromState: 'transcription_owner_approved',
        toState: 'transcript_redacted',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'transcript redaction: PII, phone, address, names',
    }),
    Object.freeze({
        stepId: 'pilot-06',
        name: 'transcript_segments',
        fromState: 'transcript_redacted',
        toState: 'json_extraction_ready',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'transcript segments ready for JSON extraction',
    }),
    Object.freeze({
        stepId: 'pilot-07',
        name: 'json_extraction',
        fromState: 'json_extraction_ready',
        toState: 'json_dry_run',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'kundali/vastu JSON extraction from transcript',
    }),
    Object.freeze({
        stepId: 'pilot-08',
        name: 'json_preview',
        fromState: 'json_dry_run',
        toState: 'write_approval_required',
        requiresOwnerApproval: true,
        auditRequired: true,
        description: 'JSON preview -> owner approval for file write',
    }),
    Object.freeze({
        stepId: 'pilot-09',
        name: 'write_outputs',
        fromState: 'write_approval_required',
        toState: 'written',
        requiresOwnerApproval: true,
        auditRequired: true,
        description: 'write transcript.txt, segments.json, extract.json, audit.json',
    }),
    Object.freeze({
        stepId: 'pilot-10',
        name: 'rollback_available',
        fromState: 'written',
        toState: 'rollback_available',
        requiresOwnerApproval: false,
        auditRequired: true,
        description: 'rollback available after write',
    }),
]);
export const OWNER_PILOT_WORKFLOW_SF34 = Object.freeze({
    version: '0.1.103',
    steps: WORKFLOW_STEPS,
    totalSteps: WORKFLOW_STEPS.length,
    ownerApprovalSteps: WORKFLOW_STEPS.filter(s => s.requiresOwnerApproval).length,
    auditRequiredSteps: WORKFLOW_STEPS.filter(s => s.auditRequired).length,
    noAutonomousExecution: true,
    rollbackAvailable: true,
});
//# sourceMappingURL=ownerPilotWorkflowSf34.js.map